import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import ImpersonationBanner from "./ImpersonationBanner";
import UnverifiedEmailBanner from "./UnverifiedEmailBanner";
import CookieConsent from "./CookieConsent";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { t } = useTranslation("common");
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-2 focus:left-2 focus:rounded-md focus:bg-indigo-600 focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-white focus:shadow-lg"
      >
        {t("skipToContent")}
      </a>
      <ImpersonationBanner />
      <Navbar />
      <UnverifiedEmailBanner />
      <main id="main-content" className="mx-auto w-full max-w-6xl flex-1 px-4 py-4 md:py-8">{children}</main>
      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-3 flex flex-col sm:flex-row flex-wrap items-center justify-between gap-2 text-xs text-slate-500">
          <span>{t("footer")}</span>
          <nav aria-label="Footer" className="flex flex-wrap items-center justify-center gap-3">
            <Link to="/privacy" className="hover:text-slate-700 transition-colors">
              {t("legalFooter.privacy")}
            </Link>
            <span className="text-slate-300">|</span>
            <Link to="/terms" className="hover:text-slate-700 transition-colors">
              {t("legalFooter.terms")}
            </Link>
            <span className="text-slate-300">|</span>
            <Link to="/cookies" className="hover:text-slate-700 transition-colors">
              {t("legalFooter.cookies")}
            </Link>
            <span className="text-slate-300">|</span>
            <Link to="/support" className="hover:text-slate-700 transition-colors">
              {t("legalFooter.support")}
            </Link>
          </nav>
        </div>
      </footer>
      <CookieConsent />
    </div>
  );
}
